import React, { Fragment, useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { findAllBySalarie } from "../../../../../services/Folder__Service";
import { findOne } from "../../../../../services/Salarie__Service";
import navContext from "../../../../Context/navContext";
import notifyContext from "../../../../Context/notifyContext";
import folderImg from "../../../../../assets/folder.svg";
import NumericLabel from "react-pretty-numbers";

import Loader from "../../../../Loader/Loader";
import { PARAMS_NUMBERS } from "../../../../../services/config";
import CardSalarie from "../../../../CardSalarie/CardSalarie";

const ListFolder = () => {
  const [folders, setFolders] = useState([]);
  const [salarie, setSalarie] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingFolders, setIsLoadingFolders] = useState(true);
  const [isLoadingSalarie, setIsLoadingSalarie] = useState(true);
  const [reload, setReload] = useState(false);

  const nav = useContext(navContext);
  const notify = useContext(notifyContext);

  const redirect = useNavigate();

  const paramsRoute = useParams();

  useEffect(() => {
    if (reload) {
      setIsLoading(true);
      setIsLoadingFolders(true);
      fetchAllFolderBySalarie(paramsRoute.id);
    }
  }, [reload]);

  useEffect(() => {
    nav({
      links: [
        {
          href: "/main/salarie",
          linkname: "Salariés",
        },
        {
          href: "",
          linkname: "Dossiers",
        },
      ],
      children: "",
    });
  }, [salarie]);

  useEffect(() => {
    fetchAllFolderBySalarie(paramsRoute.id);
    fetchSalarie(paramsRoute.id);
  }, []);

  const fetchAllFolderBySalarie = async (id) => {
    findAllBySalarie(id)
      .then((response) => {
        setFolders(response.data);
        setIsLoadingFolders(false);
        setReload(false);
      })
      .catch((error) => {
        setIsLoadingFolders(false);
        setReload(false);

        notify(error);
      });
  };

  const fetchSalarie = async (id) => {
    findOne(id)
      .then((response) => {
        setSalarie(response.data);
        setIsLoadingSalarie(false);
      })
      .catch((error) => {
        setIsLoadingSalarie(false);
      });
  };

  useEffect(() => {
    if (!isLoadingFolders && !isLoadingSalarie) {
      setIsLoading(false);
    }
  }, [isLoadingFolders, isLoadingSalarie]);

  return (
    <Fragment>
      <CardSalarie initialSalarie={salarie} />
      <div className="folder__items">
        {folders.length > 0 ? (
          folders.map((folder, key) => {
            return (
              <div
                className="folder__item"
                title={folder.name}
                onDoubleClick={() => {
                  redirect(`${folder.id}/files/`);
                }}
                key={key}
              >
                <img src={folderImg} alt="folder" className="folder__image" />
                <p className="folder__name">
                  {folder.name.length < 20
                    ? folder.name
                    : folder.name.substring(0, 19) + "..."}
                </p>
                <p className="folder__count-file">
                  <NumericLabel params={PARAMS_NUMBERS}>
                    {folder.countFile}
                  </NumericLabel>{" "}
                </p>
              </div>
            );
          })
        ) : (
          <p>Aucun dossier</p>
        )}
      </div>
      {isLoading && <Loader loadingMsg="Chargement..." />}
    </Fragment>
  );
};

export default ListFolder;
